import isEqual from 'lodash/isEqual'
import omitBy from 'lodash/omitBy'

import type { FilterDefinition, FilterModel } from '@/components/lemmala-design-system/table/types'

/** Returns the filter model with `field` dropped, leaving the original untouched. */
export const withoutFilterField = (model: FilterModel, field: string): FilterModel => {
  const { [field]: _removed, ...rest } = model
  return rest
}

const isEmptySetFilter = (filter: FilterDefinition) =>
  filter.filterType === 'set' && filter.values.length === 0

// AG Grid keeps a set filter whose values all left its options as an empty selection: no rows, no chip.
export const withoutEmptySetFilters = (model: FilterModel): FilterModel =>
  omitBy(model, isEmptySetFilter)

// Whether the grid still applies everything requested; AG Grid drops set values missing from the options.
export const appliesFilterModel = (requested: FilterModel, applied: FilterModel): boolean =>
  Object.entries(requested).every(([key, filter]) => {
    const current = applied[key]
    if (filter.filterType !== 'set') return isEqual(current, filter)
    return current?.filterType === 'set' && filter.values.every((v) => current.values.includes(v))
  })
